import { useInquiryUnreadCount } from "@app/shared/hooks/use-inquiry-unread-count.hook";
import { URLS } from "@core/shared/utils";
import { buttonVariants } from "@design-system/components/Button";
import { BaseLink } from "@design-system/components/link";
import { cn } from "@design-system/lib/utils";
import { trans } from "@mongez/localization";
import { MessageSquareText } from "lucide-react";

export function InquiriesShortcut() {
  const { isEnabled, unreadCount } = useInquiryUnreadCount();

  if (!isEnabled) return null;

  const label = trans("inquiries.navigation");
  const accessibleLabel =
    unreadCount > 0
      ? `${label}: ${trans("inquiries.unreadCue", { count: unreadCount })}`
      : label;

  return (
    <BaseLink
      to={URLS.inquiries.list}
      title={label}
      aria-label={accessibleLabel}
      className={cn(
        buttonVariants({ variant: "ghost", size: "icon" }),
        "relative rounded-full transition hover:bg-primary/10 hover:text-primary",
      )}
    >
      <MessageSquareText className="size-5" />
      {unreadCount > 0 && (
        <span
          className="absolute -end-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full border-2 border-white bg-rose-500 px-1 text-[10px] font-black leading-none text-white shadow-sm dark:border-slate-950"
          aria-hidden="true"
        >
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </BaseLink>
  );
}
